import { motion } from "framer-motion";
import { Quote } from "lucide-react";

export const PrincipalSection = () => {
  return (
    <section className="py-16 md:py-24 bg-slate-50" data-testid="principal-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="order-2 lg:order-1"
          >
            <span className="text-secondary font-medium text-sm uppercase tracking-wider">
              From the Principal's Desk
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4">
              A Message of Inspiration
            </h2>
            <div className="section-divider mb-6"></div>

            <div className="relative">
              <Quote className="absolute -top-2 -left-2 w-12 h-12 text-secondary/20" />
              <blockquote className="text-gray-600 text-lg italic leading-relaxed pl-8">
                "At ID4U School, we believe that every child is unique and possesses 
                unlimited potential. Our role as educators is to nurture this potential, 
                provide guidance, and create opportunities for students to discover their 
                passions and excel in their chosen paths.
                <br /><br />
                We are committed to providing a safe, inclusive, and stimulating 
                environment where students can grow academically, socially, and emotionally. 
                Together with parents, we strive to shape responsible citizens who will 
                contribute positively to society."
              </blockquote>
            </div>

            <div className="mt-8 flex items-center gap-4">
              <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center text-white font-heading text-xl font-bold">
                DR
              </div>
              <div>
                <h4 className="font-heading text-lg font-semibold text-gray-900">
                  Dr. Rajesh Kumar
                </h4>
                <p className="text-muted-foreground">Principal, ID4U School</p>
                <p className="text-sm text-secondary">Ph.D. in Education | 25+ Years Experience</p>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="order-1 lg:order-2"
          >
            <div className="relative">
              <div className="absolute -inset-4 bg-primary/10 rounded-3xl"></div>
              <div className="relative rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=800&q=80"
                  alt="Principal"
                  className="w-full h-[500px] object-cover"
                />
              </div>
              {/* Decorative element */}
              <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-secondary rounded-2xl flex items-center justify-center text-white">
                <div className="text-center">
                  <div className="text-2xl font-bold">25+</div>
                  <div className="text-xs">Years Exp.</div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
